module.exports = __webpack_public_path__ + "img/bhagawoti.00aa088d.png";